/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'analytics': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M897.1 781.6V144h-96v.1h-129v-.1h-96v192h-226v190.2h-125v-.1h-96v255.4h-64v96h895.2v-96h-63.2zm-96-541.5v541.5h-129V240.1h129zM576.1 432v349.6h-130V432h130zm-351 190.2h125v159.4h-125V622.2z"/>'
  }
})
